var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_753_7940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.08317 15.8332H6.6665C3.33317 15.8332 1.6665 14.9998 1.6665 10.8332V6.6665C1.6665 3.33317 3.33317 1.6665 6.6665 1.6665H13.3332C16.6665 1.6665 18.3332 3.33317 18.3332 6.6665V10.8332C18.3332 14.1665 16.6665 15.8332 13.3332 15.8332H12.9165C12.6582 15.8332 12.4082 15.9582 12.2498 16.1665L10.9998 17.8332C10.4498 18.5665 9.54984 18.5665 8.99984 17.8332L7.74984 16.1665C7.6165 15.9832 7.30817 15.8332 7.08317 15.8332Z",
    stroke: "#00a14b",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3305 9.16667H13.338",
    stroke: "#00a14b",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99607 9.16667H10.0036",
    stroke: "#00a14b",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66209 9.16667H6.66957",
    stroke: "#00a14b",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_753_7940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.6c4cdf3ce57a030bfddd42cda1492fcd.svg";
export { ForwardRef as ReactComponent };